import { call, put, select, all } from "redux-saga/effects"
import * as actions from "../action_creators"
import * as client from "../../api/client"
import { getProfile } from "../selectors"
import { createTeam, sendBulkInvites } from "./team_sagas"
import {
    getCompanyTeamId,
    checkIfAllFalsyValues,
} from "../../util/onboarding_utils"
import { genColor } from "../../util/tag_utils"
import { handleCreateTag } from "./tag_sagas"
import { prepareOnboardingTags } from "../../util/ui_saga_utils"
import { convertProfileRemoteToRedux } from "../../util/redux_utils"
import { handleIncrementOnboardingStep, handleAgreeToTerms } from "./profile_sagas"
import { handleUpdateAccountName } from "./account_sagas"

export function* handleNavigateAndFetchAccountCustomer({ history }) {
    yield call(history.push, "/settings")
}

export function* handleNavigateAndPatch({ patchMeta }) {
    const { onboardingStep } = yield select(getProfile)

    if (onboardingStep === "done") return
    // make patches to user profile
    switch (onboardingStep) {
        case "1":
        case "":
            break
        case "2":
        case "team-onboarding":
            yield call(handleSetNameAndPassword, patchMeta)
            break
        case "3":
            yield call(handleOnboardingTeam, patchMeta)
            break
        case "4":
            yield call(handleOnboardingCreateTags, patchMeta)
            break
        default:
            break
    }

    // update onboarding stage and navigate
    yield call(handleIncrementOnboardingStep)
}

export function* handleSetNameAndPassword(patchMeta) {
    const { fullName, password, agreeToTerms } = patchMeta

    const meta = {
        fullName,
        password,
    }
    try {
        const resp = yield call(client.postOnboardingProfile, meta)
        if (resp === undefined) {
            return
        }
        const profile = yield select(getProfile)
        const profileIngressShape = convertProfileRemoteToRedux(profile)
        yield put(
            actions.receiveProfile({
                ...profileIngressShape,
                fullName,
            }),
        )
        // update account name with full name 
        if (fullName) {
            yield call(handleUpdateAccountName, { companyName: fullName} )
        }
        if (agreeToTerms) {
            yield call(handleAgreeToTerms)
        }
    } catch (e) {
        return
    }
}

export function* createOnboardingTeam(companyName) {
    const { name, email, id } = yield select(getProfile)

    // calculate team name
    const teamName = companyName
        ? companyName
        : name
            ? `${name}'s Team`
            : `${email.address}'s Team`

    const team = {
        ownerId: id,
        color: genColor(teamName),
        name: teamName,
        shortName: teamName[0],
        description: "",
    }
    const teamId = yield call(createTeam, { team })
    return teamId
}

export function* handleOnboardingTeam(meta) {
    const { fields, companyName } = meta
    // skip if no values on meta
    const shouldSkip = checkIfAllFalsyValues(meta)
    if (shouldSkip) {
        return
    }

    // update account name with company name
    if (companyName) {
        yield put(actions.updateAccountName(companyName))
    }

    // if no invite emails, don't create team
    const noEmails = checkIfAllFalsyValues(fields, "email")
    if (noEmails) {
        return
    }

    // create team
    const teamId = yield call(createOnboardingTeam, companyName)

    if (!teamId) return

    // create and send invites to team members
    yield call(sendBulkInvites, teamId, meta.fields,)
}

export function* handleOnboardingCreateTags(meta) {
    const { personalTeamId, id, memberships } = yield select(getProfile)

    // company team id is the non-personal team
    const companyTeamId = getCompanyTeamId(memberships, personalTeamId)
    // determine team that tags are for
    // if no company team id, use personal team
    const tagTeamId = companyTeamId ? companyTeamId : personalTeamId
    // groom tags, remove duplicate tag names
    const tags = prepareOnboardingTags(meta, tagTeamId, id)
    yield all(
        Object.keys(tags).map(tagId => {
            const tag = { ...tags[tagId] }
            return call(handleCreateTag, { tag })
        }),
    )
}



// WEBPACK FOOTER //
// ./src/redux/sagas/ui_sagas.js